<template>
	<div class="nav vue-alerts" :mode="activeMode">
		<NotificationList
			class="vue-alerts__items"
			:items="alerts"
			v-if="hasAlerts"
			@dismissClick="onNotificationDismissed"
			@saveClick="onNotificationDismissed"
			:showingNavigation="showingNavigation"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NotificationList from './components/vue-notification-list.vue';
import propsMixin from './mixins/parent-component-props';
import getCompanyId from '@/composables/get-companyid';

export default {
	name: 'VueAlerts',
	mixins: [propsMixin],
	data() {
		return {
			activeMode: 'light',
			connection: undefined,
			username: '',
			checked: false,
			newMessage: '',
			messages: [],
			myConnectionId: '',
			ready: false
		};
	},
	props: {
		hideAfterSeconds: {
			type: Number,
			default: 5
		},
		showingNavigation: {
			type: Boolean,
			default: true
		}
	},
	components: {
		NotificationList
	},
	async created() {
		if (this.showingNavigation) {
			await this.getUnShownNotificationsAction(getCompanyId(this.$route));
		}

		if (this.hubReady) {
			await this.addMessageHandlerAction({
				target: 'newMessage',
				handler: this.onNewMessage
			});
		}
	},
	watch: {
		async hubReady(newValue) {
			if (newValue) {
				if (newValue) {
					await this.addMessageHandlerAction({
						target: 'newMessage',
						handler: this.onNewMessage
					});
				}
			}
		}
	},
	computed: {
		...mapGetters('user', [
			'userToken',
			'unShownNotificationItems',
			'VUE_APP_SIGNALR_CONNECTION'
		]),
		...mapGetters('hub', ['hubReady']),
		...mapGetters('communicationHub', ['activeToasts']),
		hasAlerts() {
			return this.alerts.length > 0 || this.activeToasts.length > 0;
		},
		alerts() {
			const alertItems = this.unShownNotificationItems;

			if (alertItems.length > 0) {
				this.setShownTimeout(alertItems);
			}

			return alertItems;
		}
	},
	methods: {
		...mapActions('user', [
			'alertsShownAction',
			'getUnShownNotificationsAction',
			'dismissNotificationAction',
			'addAlertAction'
		]),
		...mapActions('hub', ['addMessageHandlerAction']),
		...mapActions('logging', ['logEventAction']),
		setShownTimeout(alertItems) {
			const companyId = getCompanyId(this.$route);
			const timeoutMils = this.hideAfterSeconds * 1000;

			setTimeout(this.alertsShownAction, timeoutMils, {
				notificationItems: alertItems,
				companyId: companyId
			});
		},
		onNewMessage(message) {
			const messageObj = JSON.parse(message);

			this.addAlertAction(messageObj);

			this.setShownTimeout([messageObj]);

			this.logEventAction({
				data: { event: 'Receive New Alert', eventData: messageObj },
				route: this.$route,
				target: 'VueAlerts'
			});
		},
		async onNotificationDismissed(params) {
			await this.dismissNotificationAction(params);
		}
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar('borderless');

.vue-alerts {
	position: fixed;
	display: flex;
	justify-content: flex-end;
	top: 56px;
	width: 100%;
	max-width: 1402px;
	z-index: $z-level4;
	pointer-events: none;
}
</style>
